module.exports = {
    "metadata": {
        "name": "broadcaster",
        "short_name": "CM",
        "description": "Documentacion APIs Concepto Movil. CM.",
        "language": "es",
        "url": "http://localhost",
        "pathPrefix": "/es",
        "gaTrackingId": null,
        "siteImage": null,
        "favicon": "/assets/favicon.png",
        "themeColor": "#ff0000"
    },
    "header": {
        "logo": "/assets/broadcaster.svg",
        "logoLink": "/",
        "helpUrl": "",
        "links": [],
        "enabled": true
    },
    "sidebar": {
        "enabled": true,
        "ignoreIndex": false,
        "forcedNavOrder": [],
        "expanded": [],
        "groups": [
            {
                "order": 2,
                "path": "/sms",
                "title": "SMS",
                "icon": "/assets/iconos/ico_sms.png"
            },
            {
                "order": 3,
                "path": "/rcs",
                "title": "RCS",
                "icon": "/assets/iconos/ico_rcs.png"
            },
            {
                "order": 5,
                "path": "/voice",
                "title": "Voz",
                "icon": "/assets/iconos/ico_voz.png"
            },
            {
                "order": 4,
                "path": "/mail",
                "title": "Mail",
                "icon": "/assets/iconos/ico_mail.png"
            },
            {
                "order": 6,
                "path": "/shorturl",
                "title": "shortURL",
                "icon": "/assets/iconos/ico_short_url.png"
            },
            {
                "order": 1,
                "path": "/whatsapp",
                "title": "Whatsapp",
                "icon": "/assets/iconos/ico_whatsapp.png"
            },
            {
                "order": 7,
                "path": "/ventachat",
                "title": "VentaChat",
                "icon": "/assets/iconos/ico_ventachat.svg"
            },
            {
                "order": 8,
                "path": "/api-externa",
                "title": "API externa",
                "icon": "/assets/iconos/ico_api_externa.png"
            }
        ],
        "links": [
            {
                "text": "Concepto Movil",
                "link": "https://conceptomovil.com"
            },
            {
                "text": "Broadcaster",
                "link": "https://www.broadcastermobile.com/"
            }
        ],
        "poweredBy": {}
    },
    "pwa": {
        "manifest": {
            "name": "APIs de Concepto Móvil",
            "short_name": "APIs de Concepto Móvil",
            "start_url": "/",
            "background_color": "#6b37bf",
            "theme_color": "#6b37bf",
            "display": "standalone",
            "crossOrigin": "anonymous",
            "icon": "static/assets/favicon-32x32.png",
            "description": "Documentacion APIs Concepto Movil. CM.",
            "cache_busting_mode": "none",
            "include_favicon": false,
            "lang": "es"
        },
        "enabled": true
    },
    "social": {
        "facebook": "https://www.facebook.com/broadcastermobile/",
        "github": "",
        "gitlab": "",
        "instagram": "",
        "linkedin": "https://mx.linkedin.com/company/concepto-m-vil",
        "mail": "",
        "gmail": "",
        "slack": "",
        "twich": "",
        "twitter": "https://twitter.com/broadcaster_mx",
        "youtube": "https://www.youtube.com/channel/UCINA9Zz7TTgdydCxaQeoc2Q"
    },
    "features": {
        "editOnRepo": {
            "editable": false,
            "location": "https://github.com",
            "type": "github"
        },
        "toc": {
            "show": true,
            "depth": 4
        },
        "previousNext": {
            "enabled": true,
            "arrowKeyNavigation": true
        },
        "scrollTop": false,
        "showMetadata": true,
        "propagateNetlifyEnv": true,
        "pageProgress": {
            "enabled": true,
            "excludePaths": [
                "/"
            ],
            "height": 3,
            "prependToBody": false,
            "color": "#A05EB5",
            "includePaths": [
                "/configuration/settingup/features"
            ]
        },
        "mermaid": {
            "language": "mermaid",
            "theme": "dark",
            "options": {},
            "width": 400,
            "height": 300
        },
        "rss": {
            "enabled": true,
            "showIcon": false,
            "title": "APIs de Concepto Móvil",
            "copyright": "2021 Concepto Móvil",
            "webMaster": "CM",
            "managingEditor": "CM",
            "categories": [
                "Docs as Code",
                "GatsbyJS"
            ],
            "ttl": 60,
            "matchRegex": "^/",
            "outputPath": "/rss.xml",
            "generator": "APIs Concepto Móvil"
        },
        "darkMode": {
            "enabled": false,
            "default": false
        },
        "publishDraft": false,
        "fullScreenMode": {
            "enabled": false,
            "hideHeader": true,
            "hideToc": true,
            "hideSidebar": true
        }
    }
};